import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from '@/request/api/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Pagination from '@/components/Pagination'
import Meta from 'vue-meta'
import VueFunction from './utils/VueFunction'
import IDCard from "china-id-card";

Vue.use(VueFunction)

Vue.prototype.$api = api
Vue.prototype.$bus = new Vue()
//1 H5
//2 小程序
Vue.prototype.$shareType = 2


Vue.config.productionTip = false

Vue.directive('enterToNext', {
  inserted: function (el) {
    // console.log("enterToNext...");
    //let frm = el.querySelector('.el-form');
    let inputs = el.querySelectorAll('input')
    // console.log(inputs)
    //绑定回写事件
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('keyFocusIndex', i)
      inputs[i].addEventListener('keyup', (ev) => {
        if (ev.keyCode === 13) {
          let targetTo = ev.srcElement.getAttribute('keyFocusTo')
          if (targetTo) {
            this.$refs[targetTo].$el.focus()
          } else {
            var attrIndex = ev.srcElement.getAttribute('keyFocusIndex')
            var ctlI = parseInt(attrIndex)
            if (ctlI < inputs.length - 1) inputs[ctlI + 1].focus()
          }
        }
      })
    }
  }
})
Vue.use(VueQuillEditor)

// 全局设置 elementUI的$message的配置属性
const messages = ['success', 'warning', 'info', 'error']
messages.forEach((type) => {
  ElementUI.Message[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
      // 默认配置
      options.duration = 3000
      options.showClose = true
      options.offset = 70
    }
    options.type = type
    options.customClass = 'messageIndex'

    return ElementUI.Message(options)
  }
})
Vue.use(ElementUI)
Vue.use(Meta)

Vue.component('Pagination', Pagination)

var vue = new Vue({
  router,
  store,
  data() {
    return {
      title: '',
      keywords: '',
      description: '',
    }
  },
  metaInfo() {
    return {
      title: '珠海瑞启智慧科技有限公司官网,瑞启,瑞启智慧,瑞启科技,RayQee,WoYou,WoYou工资,人力资源,人资,AI+大数据,软件,工具,互联网+,就业,网络工具',
      meta: [
        { name: 'keywords', content: '珠海,瑞启,科技,公司,RayQee,网络,WoYou,WoYou工资,人力资源,人资,劳务派遣,业务系统,管理系统,AI,大数据,软件,工具,互联网+,就业,找工作,网络工具,人才中介,猎头,分佣,代发,分账' },
        { name: 'description', content: '珠海瑞启智慧科技有限公司(RayQee)是一家致力于使用AI与大数据技术促进人资行业发展,通过人力资源为企业发展赋能的高科技公司.瑞启"WoYou工资"系列软件产品,突破传统模式,以"互联网+"和"新质生产力"理念使用新技术为人资领域提供完整产业链及衍生服务."WoYou工资"免费版,作为能够提供产业链及衍生服务的管理软件及业务工具,让更多人力资源,人力密集型,中小型企业以及灵活用工项目得以拓展业务并从人资衍生业务中获利.' }
      ]
    }
  },
  async mounted() {
    // try {
    //   const res = await this.$api.manage.getWebSiteConfigs()
    //   if(res.Error === false && res.Data) {
    //     res.Data.forEach(v => {
    //       if(v.Key === 'SITE_NAME') {
    //         this.title = v.Value
    //       }else if(v.Key === 'SITE_KEYWORDS') {
    //         this.keywords = v.Value
    //       }else if(v.Key === 'SITE_DESCRIPITION') {
    //         this.description = v.Value
    //       }
    //     })
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  },
  render: (h) => h(App)
}).$mount('#app')

export default vue